import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { request } from "services/request";

const resource = "api/adminpanel";

const listQuery = {
    orderby: ["id desc"],
};

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...listQuery });
    return request(`${resource}/getAllDrivers${query}`, { method: "GET" }, { countInHeaders: true });
};

const list = (params: {}) => request(`${resource}/getAllDrivers${containsQuery(params)}`, { method: "GET" });

export { index, list };
